/**
 * Browser assets of the document renderer (ADR-017): the typst.ts compiler, shipped gzipped as one of the portal's
 * own files (the raw module is 27 MiB, over the 25 MiB file limit of Cloudflare Pages), and the brand fonts that
 * teslyn-core embeds. Loaded on the first PDF only.
 */
import wasmUrl from 'virtual:typst-compiler-wasm';
import archivoRegular from '../../../../crates/teslyn-core/fonts/archivo/Archivo-Regular.ttf?url';
import archivoMedium from '../../../../crates/teslyn-core/fonts/archivo/Archivo-Medium.ttf?url';
import archivoSemiBold from '../../../../crates/teslyn-core/fonts/archivo/Archivo-SemiBold.ttf?url';
import archivoBold from '../../../../crates/teslyn-core/fonts/archivo/Archivo-Bold.ttf?url';
import archivoItalic from '../../../../crates/teslyn-core/fonts/archivo/Archivo-Italic.ttf?url';
import plexRegular from '../../../../crates/teslyn-core/fonts/ibm-plex-mono/IBMPlexMono-Regular.ttf?url';
import { inflateIfGzip, type RendererAssets } from './render.ts';

async function bytes(url: string): Promise<ArrayBuffer> {
  const res = await fetch(url);
  if (!res.ok) throw new Error(`Could not load ${url} (${res.status}).`);
  return res.arrayBuffer();
}

export const browserAssets: RendererAssets = {
  wasm: async () => inflateIfGzip(await bytes(wasmUrl)),
  fonts: async () =>
    (
      await Promise.all(
        [archivoRegular, archivoMedium, archivoSemiBold, archivoBold, archivoItalic, plexRegular].map(bytes),
      )
    ).map((b) => new Uint8Array(b)),
};

/** Offer the PDF to the user as a download. */
export function downloadPdf(pdf: Uint8Array, fileName: string): void {
  const blob = new Blob([pdf as BlobPart], { type: 'application/pdf' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = fileName;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 10_000);
}
